Object.defineProperty(exports, "__esModule", {
  value: true,
});

// Customizable Area Start
exports.validationApiContentType = "application/json";
exports.httpGetMethod = "GET";

exports.ApiUrls = {
  bannersList: "bx_block_banners/banners",
  slotManagementList: "bx_block_slot_management/slot_masters",
  mobileServices: "mobile/bx_block_order_management/mobile_services",
};

exports.Strings = {
  token: "token",
  pageTitle: "Banners",
  noRecordFounds: "No Banners Found",
};
// Customizable Area End
